import React from 'react';
import clsx from 'clsx';
import '@/assets/styles/components/table-loader.styles.scss';
import { TableLoaderProps } from './table-loader.types';

const DEFAULT_LOADING_TEXT = 'Yükleniyor...';

export const TableLoader: React.FC<TableLoaderProps> = ({ text = DEFAULT_LOADING_TEXT, variant = 'block', className }) => (
	<div
		className={clsx('table-loader', `table-loader--${variant}`, className)}
		aria-busy="true">
		<div
			className="table-loader__spinner"
			role="status"
			aria-live="polite">
			<span className="table-loader__ring" />
			<span className="table-loader__text">{text}</span>
		</div>
	</div>
);

export default TableLoader;
